{ "id": "cape-bouffante", "name": "Cape Bouffante", "slot": "cape", "set": "bouftou", "tier": 2, "price": 100, "icon": "icons/items/cape-bouffante", "stats": { "vitalite": 40 } }
